import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import CircularProgress from "@material-ui/core/CircularProgress";

import Login from "./Login";
import fb from "./ConfiguredFirebase";

const stringify = require("csv-stringify/lib/sync");

const useStyles = makeStyles({
  button: {
    margin: "20px",
  },
});

const buildLongCsv = ({ surveys }) => {
  let csvContent = "data:text/csv;charset=utf-8,";

  let rows = [];
  let columNames = [
    "createdAt",
    "questionaireId",
    "email",
    "userName",
    "company",
    "maxScoreQuestionaire",
    "scoreQuestionaire",
    "category",
    "sequence",
    "questionDescription",
    "singleAnswer",
    "scoreQuestion",
    "nChoices",
    "answerDescription",
    "weight",
    "answer",
  ];
  rows.push(columNames);
  let surveyRow, questionRow, answerRow;

  let questionaireFields = [
    "createdAt",
    "id",
    "email",
    "userName",
    "company",
    "maxScore",
    "totalScore",
  ];
  let questionFields = [
    "category",
    "sequence",
    "description",
    "singleAnswer",
    "score",
  ];

  const parseField = (fieldValue) => {
    if (typeof fieldValue === undefined) {
      return "";
    }
    return fieldValue;
  };

  surveys.forEach((survey) => {
    surveyRow = [];
    questionaireFields.forEach((questionaireField) => {
      surveyRow.push(parseField(survey[questionaireField]));
    });
    survey.questions.forEach((question) => {
      questionRow = [];
      questionFields.forEach((field) => {
        questionRow.push(parseField(question[field]));
      });
      questionRow.push(question.choices.length);
      question.choices.forEach((choice, idx) => {
        answerRow = [];
        answerRow.push(choice);
        answerRow.push(question.weights[idx]);
        answerRow.push(!question.answers[idx] ? 0 : 1);
        rows.push([...surveyRow, ...questionRow, ...answerRow]);
      });
    });
  });

  let csv = encodeURI(
    csvContent +
      stringify(rows, {
        delimiter: ";",
        cast: {
          boolean: (value, context) => (value ? "1" : "0"),
          number: (value, context) => {
            let x = parseFloat(value).toString().replace(".", ",");
            return x;
          },
        },
      })
  );

  let downloadLink = document.createElement("a");
  downloadLink.textContent = "download";
  downloadLink.download = "results.csv";
  downloadLink.href = csv;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};

const ResultDownloader = () => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(false);
  useEffect(() => {
    fb.auth.onAuthStateChanged((user) => {
      setUser(user);
    });
  }, []);

  const Logout = () => {
    setLoading(true);
    fb.auth.signOut().then(() => {
      setLoading(false);
    });
  };

  const downloadResults = () => {
    setLoading(true);
    let surveys = [];
    fb.firestore
      .collection("Antworten")
      .limit(1000)
      .get()
      .then((docs) => {
        docs.forEach((doc) => surveys.push({ id: doc.id, ...doc.data() }));
        buildLongCsv({ surveys });
        setLoading(false);
      });
  };

  if (loading) {
    return <CircularProgress color="secondary" />;
  }

  if (user) {
    return (
      <Container>
        <Grid container direction="column" justify="center">
          <Button
            className={classes.button}
            variant="contained"
            color="secondary"
            style={{ cursor: "pointer" }}
            onClick={downloadResults}
          >
            Download
          </Button>
          <Button
            className={classes.button}
            variant="contained"
            color="primary"
            style={{ cursor: "pointer" }}
            onClick={Logout}
          >
            Logout
          </Button>
        </Grid>
      </Container>
    );
  }
  return <Login />;
};

export default ResultDownloader;
